module.exports = __webpack_public_path__ + "static/img/cus_06_pre.12d411ba.jpg";